import { Theme, Typography } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";
import { TreeView } from "@mui/x-tree-view/TreeView";
import { OtherNutrientGroup } from "shared-ui/NutrientAmount/types";
import NutrientTreeItem from "./NutrientTreeItem";
import { CollapseIcon, ExpandIcon, LeafIcon } from "./StyledTreeItem";
import { generateTreeStyles } from "./styles";

const useStyles = makeStyles((theme: Theme) => createStyles(generateTreeStyles(theme.palette.grey[300], theme)));

export interface OtherTreeProps {
  other: OtherNutrientGroup;
  displayDri: boolean;
}

const OtherTree = ({ other, displayDri }: OtherTreeProps) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Typography className={classes.title} variant="body2" sx={{ fontWeight: 600 }}>
        Other
      </Typography>
      <div className={classes.content}>
        <TreeView
          className={classes.tree}
          defaultExpanded={["1"]}
          defaultCollapseIcon={<CollapseIcon />}
          defaultExpandIcon={<ExpandIcon />}
          defaultEndIcon={<LeafIcon />}
        >
          <NutrientTreeItem
            isRoot={true}
            nodeId="1"
            displayDri={displayDri}
            nutrientAmount={other["Alcohol"]} />
          <NutrientTreeItem
            isRoot={true}
            nodeId="2"
            displayDri={displayDri}
            nutrientAmount={other["Caffeine"]} />
          <NutrientTreeItem
            isRoot={true}
            nodeId="3"
            displayDri={displayDri}
            nutrientAmount={other["Choline"]} />
          <NutrientTreeItem
            isRoot={true}
            nodeId="4"
            displayDri={displayDri}
            nutrientAmount={other["Water"]} />
        </TreeView>
      </div>
    </div>
  );
};

export default OtherTree;
